import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment AppGuideItem on GuideModel {
    id
    docName
    docTitle
    hasChangesSinceLastPublish
    ongoingRevision {
      id
    }
    status
    isRevisionPlanned
    isRevisionAssesmentInProgress
    releases {
      id
      type
    }
    notices {
      id
      deletedAt
    }
    mainCategory {
      title
    }
    lastPublishedAt
  }
`);

gql(/* GraphQL */ `
  fragment ApplicationItem on ApplicationModel {
    id
    status
    underRevision
    ownerId
    owner {
      subjectId
      name
    }
  }
`);

gql(/* GraphQL */ `
  fragment AppOverviewItem on AppOverviewModel {
    id
    name
    category
    description
    url
    isStandalone
    isEmbeddable
    guideCount
    application {
      ...ApplicationItem
    }
  }
`);

export const GET_APP_OVERVIEW = gql(/* GraphQL */ `
  query GetAppOverview {
    appOverview {
      ...AppOverviewItem
    }
  }
`);

export const GET_APP_DETAILS = gql(/* GraphQL */ `
  query GetAppDetails($appId: UUID!) {
    app(appId: $appId) {
      ...AppOverviewItem
      embeddedIn {
        ...AppGuideItem
      }
      linkedTo {
        ...AppGuideItem
      }
    }
  }
`);

export const GET_APP_CATEGORIES = gql(/* GraphQL */ `
  query GetAppCategories {
    appCategories
  }
`);

export const APPLICATION_SET_STATUS = gql(/* GraphQL */ `
  mutation ApplicationSetStatus($input: ApplicationSetStatusInput!) {
    applicationSetStatus(input: $input) {
      applicationModel {
        ...ApplicationItem
      }
    }
  }
`);

export const APPLICATION_SET_OWNER = gql(/* GraphQL */ `
  mutation ApplicationSetOwner($input: ApplicationSetOwnerInput!) {
    applicationSetOwner(input: $input) {
      applicationModel {
        ...ApplicationItem
      }
    }
  }
`);

export const APPLICATION_SET_UNDER_REVISION = gql(/* GraphQL */ `
  mutation ApplicationSetUnderRevision($input: ApplicationSetUnderRevisionInput!) {
    applicationSetUnderRevision(input: $input) {
      applicationModel {
        ...ApplicationItem
      }
    }
  }
`);

export const GET_GUIDES_FOR_APP = gql(/* GraphQL */ `
  query GetGuidesForApp {
    guides(order: { docName: ASC }) {
      ...GuideOverviewItem
    }
  }
`);

export const APPLICATION_UPDATE_DETAILS = gql(/* GraphQL */ `
  mutation ApplicationUpdateDetails($input: ApplicationUpdateDetailsInput!) {
    applicationUpdateDetails(input: $input) {
      applicationModel {
        ...ApplicationItem
      }
    }
  }
`);
